// import getWeather from "../api/WeatherApi";
// import WeatherRow from "../components/WeatherRow";
// // import WeatherSummary from "../components/WeatherSummary"
// import { useEffect, useState } from "react";
// import { convertToFahrenheit, getWeatherTypeFromCode } from "../weatherUtil";

// const fetchCoordinates = (callback) => {
//     navigator.geolocation.getCurrentPosition(
//         ({ coords: { latitude, longitude } }) => {
//             callback(latitude, longitude)
//         },
//         (err) => console.error(err)
//     );
// };
// const WeatherPage = () => {
//     const [todayWeather, setTodayWeather] = useState({});
//     const [weekWeather, setWeekWeather] = useState([]);
//     const [isCelsius, setIsCelsious] = useState(true);

//     const isDay = todayWeather.isDay ?? true;
//     useEffect(() => {
//         fetchCoordinates(async (latitude, longitude) => {
//             const weatherInfo = await getWeather({ latitude, longitude });
//             convertToStateVariable(weatherInfo);
//         });
//     }, []);

//     const convertToStateVariable = (tempWeekWeather) => {
//         let fetchedWeatherInfo = [];
//         for (let i = 0; i < tempWeekWeather.daily.time.length; i++) {
//             fetchedWeatherInfo.push({
//                 date: new Date(tempWeekWeather.daily.time[i]),
//                 maxTemperature: tempWeekWeather.daily.maxTemperature_2m_max[i],
//                 minTemperature: tempWeekWeather.daily.minTemperature_2m_min[i],
//                 weatherCode: tempWeekWeather.daily.weatherCode[i],
//             });
//         }
//         setWeekWeather(fetchedWeatherInfo);

//         let currentWeather = tempWeekWeather.current_weather;
//         currentWeather.time = new Date(currentWeather.time);
//         currentWeather.isDay = currentWeather.is_day === 1;
//         currentWeather.weatherCode = tempWeekWeather.daily.weatherCode[0]; // Add weatherCode
//         setTodayWeather(currentWeather);
//     };

//     if (!weekWeather.length) {
//         return <p>Loading...</p>
//     }

//     return (
//         <div className={isDay ? "app" : "dark"}>
//             <h1 className="my-heading">Weather</h1>

//             {/* Group today's weather and unit button */}
//             <div className="weather-summary-container">
//                 <div className="weather-summary-left">
//                     <h2 className="weather-temp-text">
//                         {isCelsius
//                             ? `${todayWeather.temperature} °C`
//                             : `${convertToFahrenheit(todayWeather.temperature)} °F`}
//                     </h2>
//                     <p className="weather-type-text">{getWeatherTypeFromCode(todayWeather.weatherCode)}</p>
//                 </div>

//                 <button className="ui icon button toggle-btn" onClick={() => setIsCelsious(!isCelsius)}>
//                     {isCelsius ? "°F" : "°C"}
//                 </button>
//             </div>


//             <div className="weather-list">
//                 {weekWeather.map((weather) => (
//                     <WeatherRow
//                         weather={weather}
//                         isCelsius={isCelsius}
//                         key={weather.date}
//                     />
//                 ))}
//             </div>
//         </div>


//     );
// };

// export default WeatherPage;

import getWeather from "../api/WeatherApi";
import WeatherRow from "../components/WeatherRow";
import { useEffect, useState } from "react";
import { convertToFahrenheit, getWeatherTypeFromCode } from "../weatherUtil";

const fetchCoordinates = (callback) => {
    navigator.geolocation.getCurrentPosition(
        ({ coords: { latitude, longitude } }) => {
            callback(latitude, longitude)
        },
        (err) => console.error(err)
    );
};

const WeatherPage = () => {
    const [todayWeather, setTodayWeather] = useState({});
    const [weekWeather, setWeekWeather] = useState([]);
    const [isCelsius, setIsCelsious] = useState(true);

    const isDay = todayWeather.isDay ?? true;
    
    useEffect(() => {
        fetchCoordinates(async (latitude, longitude) => {
            const weatherInfo = await getWeather({ latitude, longitude });
            convertToStateVariable(weatherInfo);
        });
    }, []);

    const convertToStateVariable = (tempWeekWeather) => {
        let fetchedWeatherInfo = [];
        for (let i = 0; i < tempWeekWeather.daily.time.length; i++) {
            fetchedWeatherInfo.push({
                date: new Date(tempWeekWeather.daily.time[i]),
                maxTemperature: tempWeekWeather.daily.maxTemperature_2m_max[i],
                minTemperature: tempWeekWeather.daily.minTemperature_2m_min[i],
                weatherCode: tempWeekWeather.daily.weatherCode[i],
            });
        }
        setWeekWeather(fetchedWeatherInfo);

        let currentWeather = tempWeekWeather.current_weather;
        currentWeather.time = new Date(currentWeather.time);
        currentWeather.isDay = currentWeather.is_day === 1;
        currentWeather.weatherCode = tempWeekWeather.daily.weatherCode[0];
        setTodayWeather(currentWeather);
    };

    if (!weekWeather.length) {
        return (
            <div className="app loading-screen">
                <div className="loading-spinner"></div>
                <p>Fetching weather data...</p>
            </div>
        );
    }

    const formatCurrentDate = (date) => {
        return new Intl.DateTimeFormat("en-US", {
            weekday: 'long',
            month: 'short',
            day: 'numeric'
        }).format(date);
    };

    return (
        <div className={`app-container ${isDay ? "app" : "dark"}`}>
            <div className="content-wrapper">
                <h1 className="app-title">Weather Forecast</h1>

                {/* Today's Weather Summary */}
                <div className="weather-summary-container">
                    <div className="weather-summary-left">
                        <div className="current-date">{formatCurrentDate(todayWeather.time)}</div>
                        <div className="temperature-display">
                            <h2 className="weather-temp-text">
                                {isCelsius
                                    ? `${todayWeather.temperature} °C`
                                    : `${convertToFahrenheit(todayWeather.temperature)} °F`}
                            </h2>
                            <p className="weather-type-text">{getWeatherTypeFromCode(todayWeather.weatherCode)}</p>
                        </div>
                    </div>

                    <button 
                        className="unit-toggle-btn" 
                        onClick={() => setIsCelsious(!isCelsius)}
                        aria-label={`Switch to ${isCelsius ? 'Fahrenheit' : 'Celsius'}`}
                    >
                        {isCelsius ? '°F' : '°C'}
                    </button>
                </div>

                {/* Weekly Forecast */}
                <div className="weather-list-container">
                    <h2 className="forecast-title">8-Day Forecast</h2>
                    <div className="weather-list">
                        {weekWeather.map((weather) => (
                            <WeatherRow
                                weather={weather}
                                isCelsius={isCelsius}
                                key={weather.date}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WeatherPage;